import store from '@/store'
import {
  SET_SHOW_TRAINER_WECHAT,
  SET_TRAINER_INFO,
} from '../../store/mutation-types'
export default function handleNotAddWechat({ data }) {
  store.commit(`user/${SET_SHOW_TRAINER_WECHAT}`, true)
  store.commit(`user/${SET_TRAINER_INFO}`, data)
}
